import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CustomInterceptor } from './../../../helper';
import { SharedModule } from '../../shared';
import { SelectModule } from 'ng-select';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { DisplayIdModule } from '../../../directives';

import { EquipmentRoutingModule } from './equipment-routing.module';
import { EquipmentSummaryComponent, EquipmentSummaryService } from './equipment-summary';
import { EquipmentDetailComponent, EquipmentDetailService } from './equipment-detail';
import { EquipmentEditComponent, EquipmentEditService } from './equipment-edit';
import { EquipmentCreateComponent, EquipmentCreateService } from './equipment-create';
import { EquipmentAssignFormComponent } from './equipment-assign-form/equipment-assign-form.component';
import {EquipmentAssignFormService } from './equipment-assign-form/equipment-assign-form.service';
import { EquipmentCopyComponent } from './equipment-copy/equipment-copy.component';
import { EquipmentMigrateComponent } from './equipment-migrate/equipment-migrate.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    
    ReactiveFormsModule,
    SharedModule,
    EquipmentRoutingModule,
    DisplayIdModule,
    SelectModule,
    AngularMultiSelectModule,
    NgbModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule
  ],
  declarations: [
    EquipmentSummaryComponent,
    EquipmentDetailComponent,
    EquipmentEditComponent,
    EquipmentAssignFormComponent,
    EquipmentCopyComponent,
    EquipmentMigrateComponent,
    // EquipmentCreateComponent,
  ],
  providers: [
    EquipmentSummaryService,
    EquipmentDetailService,
    EquipmentEditService,
    EquipmentAssignFormService,
    // EquipmentCreateService,
    // EquipmentUpdateStatusService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
],
})
export class EquipmentModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment.module.ts